/**
 * External dependencies
 */
import { AxiosInstance, AxiosResponse } from 'axios';

/**
 * Internal dependencies
 */
import Header from '@naruto/naruto-api/src/tools/Header';
import BaseAPI from '@naruto/naruto-api/src/base';
import { BaseResponse } from './types';

class AccountAPI extends BaseAPI {
  constructor({ axios, header }: { axios: AxiosInstance; header: Header }) {
    super({ axios, header });
  }

  /* ======== API: account ======== */
  async getAccountList<Response, Params = undefined>(params?: Params): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.get<Params, AxiosResponse<Response>>('/api/admin/accounts', {
        headers: { ...this.header.header },
        params
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async getAccountInfo<Response>(accountID: string): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.get<undefined, AxiosResponse<Response>>(`/api/admin/account/${accountID}`, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async postAccount<Response, Body = undefined>(body: Body): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.post<Body, AxiosResponse<Response>>('/api/admin/account', body, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async putAccount<Response, Body = undefined>(accountID: string, body: Body): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.put<Body, AxiosResponse<Response>>(`/api/admin/account/${accountID}`, body, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async deleteAccount<Response>(accountID: string): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.delete<Body, AxiosResponse<Response>>(`/api/admin/account/${accountID}`, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }
}

export default AccountAPI;
